let searchResult = {
    data: { all: [], orders: [], combined_companies: [], contacts: [] },
    counts: { all: 0, orders: 0, combined_companies: 0, contacts: 0 },
    pagination: { current_page: 1, total_pages: 0, has_more: false },
    search_term: ''
};
let currentlySelectedTab = 'all';
let isLoading = false;
let searchTimeout = null;
// DEV-13485: every new search supersedes the one in flight. searchSeq tags each request so a late
// response for an older query can't paint over a newer one; searchXhr is aborted on supersede.
let searchSeq = 0;
let searchXhr = null;

function escapeRegExp(text) {
    return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

document.addEventListener("DOMContentLoaded", function() {
    const $searchQuery = am.$('#search_query');
    let $clearSearchButton = am.$('#display_search_close');
    if(is_mobile_or_tablet()){
        $clearSearchButton = am.$('.search-close');
    }

    $searchQuery.on('click', function() {
        setTimeout(function () {
            // Focus the search input after a small delay and trigger input event
            $searchQuery.focus().trigger('input');
        });
    });

    $searchQuery.on('input', function(event) {
        clearTimeout(searchTimeout);

        if($clearSearchButton.length > 0)
            $clearSearchButton.show();

        if (!am.$(this).val()) {
            dataUpdated();
            return;
        }

        searchTimeout = setTimeout(() => {
            const query = am.$(this).val();
            // Re-focus/click re-fires 'input'; don't re-run a search whose results are already showing
            if (query.trim() === (searchResult.search_term || '').trim() && am.$('.quickfind').hasClass('results-open')) {
                return;
            }
            if (query.length >= 2) {
                // console.log('Search triggered from input with currentTab:', currentlySelectedTab); // Debug log
                searchResult.pagination.current_page = 1; // Reset page on new search
                performSearch(am.$(this).val());
            }
        }, 300);
    });

    $clearSearchButton.on('click', function() {
        $searchQuery.val('').focus();
        clearResults();
    });

    // Initialize infinite scroll
    initInfiniteScroll();

    // Keep your existing event listeners
    $searchQuery?.on('keypress', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (searchResult.data.all.length === 1) {
                document.getElementById('id_' + searchResult.data.all[0].id)?.click();
            }
        }
    });

    $searchQuery?.on('keydown', function(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            am.$('.quickfind').removeClass('results-open');
            $searchQuery.blur();
        }
    });

    // Initialize cross icon visibility
    toggleCrossIcon();
});


function fetchResults(query, page = 1) {
    if (isLoading) return;
    isLoading = true;
    handle_loader(false);

    am.$.post('/ajax/', {
        table: "quickfind",
        search_query: query,
        fromNavBar: true,
        page: page,
        per_page: 20
    })
    .done(function(response) {
        if (page === 1) {
            // New search, replace all results
            searchResult = response;
        } else {
            // Append new results to existing ones
            searchResult.data.all = [...searchResult.data.all, ...response.data.all];
            searchResult.data.orders = [...searchResult.data.orders, ...response.data.orders];
            searchResult.data.combined_companies = [...searchResult.data.combined_companies, ...response.data.combined_companies];
            searchResult.data.contacts = [...searchResult.data.contacts, ...response.data.contacts];
            searchResult.pagination = response.pagination;
        }
        
        dataUpdated(currentlySelectedTab);
    })
    .fail(function(error) {
        console.error('Search error:', error);
    })
    .always(function() {
        isLoading = false;
        handle_loader(true);
    });
}

function abortPendingSearch() {
    searchSeq++;
    if (searchXhr) {
        searchXhr.abort();
        searchXhr = null;
    }
    isLoading = false;
}

function performSearch(query) {
    // A new search (page 1) always runs and supersedes whatever is in flight — the old
    // `if (isLoading) return` here silently dropped the latest query (DEV-13485). Infinite-scroll
    // page fetches keep the guard so they don't stack.
    if (searchResult.pagination.current_page === 1) {
        abortPendingSearch();
    } else if (isLoading) {
        return;
    }
    const seq = ++searchSeq;
    const isCurrent = () => seq === searchSeq
        && query.trim() === (document.getElementById('search_query')?.value || '').trim();
    isLoading = true;
    handle_loader(false);

    if(am.$('.results-open').length == 0){
        currentlySelectedTab = 'all';
    }
    const postData = {
        table: "quickfind",
        search_query: query,
        search_term: query,
        fromNavBar: true,
        page: searchResult.pagination.current_page,
        per_page: 20,
        active_tab: currentlySelectedTab
    };

    // console.log('Performing search with data:', postData); // Debug log

    searchXhr = am.$.post('/ajax/', postData);
    searchXhr
        .done(function(response) {
            // console.log('Search response:', response); // Debug log
            if (!isCurrent()) return; // superseded by a newer search
            if (searchResult.pagination.current_page === 1) {
                searchResult = response;
                searchResult.search_term = query;
                if (am.$('.quickfind').hasClass('results-open')) {
                    updateSearchList(currentlySelectedTab);
                } else {
                    const innerHtmlContent = dynamicHtml(currentlySelectedTab, searchResult.data[currentlySelectedTab]);
                    updateHtml(currentlySelectedTab, innerHtmlContent);
                    initInfiniteScroll();
                }
            } else {
                const dataKey = currentlySelectedTab === 'companies' ? 'combined_companies' : currentlySelectedTab;
                searchResult.data[dataKey] = [...searchResult.data[dataKey], ...response.data[dataKey]];
                searchResult.pagination = response.pagination;
                searchResult.counts = response.counts;
                searchResult.search_term = query;
                
                appendNewItems(response, currentlySelectedTab);
            }
        })
        .fail(function(error) {
            if (error?.statusText === 'abort') return;
            console.error('Search error:', error);
        })
        .always(function() {
            if (seq !== searchSeq) return; // a newer search owns the loading state
            searchXhr = null;
            isLoading = false;
            handle_loader(true);
        });
}

// Helper function to get the correct count key for a tab
function getCountKey(tab) {
    return tab === 'companies' ? 'combined_companies' : tab;
}

// Helper function to create consistent sentinel element
// (a content-shaped skeleton row, per the M3 skeleton doctrine — m3/_skeleton.scss)
function createSentinel() {
    const sentinel = document.createElement('div');
    sentinel.id = 'scroll-sentinel';
    sentinel.className = 'qf-skeleton__row';
    sentinel.innerHTML = `
        <div class="am-skeleton-stack">
            <div class="am-skeleton am-skeleton--line am-skeleton--w-60"></div>
            <div class="am-skeleton am-skeleton--line am-skeleton--w-40"></div>
        </div>
    `;
    return sentinel;
}

// Content-shaped loading state for a fresh search: a tab-strip placeholder plus result-row
// skeletons, mirroring the panel that will land (headline + type line per row). Injected by
// handle_loader() via updateHtml() so the panel opens immediately while the AJAX runs.
function buildSkeletonHtml(rowCount = 5) {
    const row = `
        <div class="qf-skeleton__row">
            <div class="am-skeleton-stack">
                <div class="am-skeleton am-skeleton--line am-skeleton--w-60"></div>
                <div class="am-skeleton am-skeleton--line am-skeleton--w-40"></div>
            </div>
        </div>`;
    return `
        <div class="search-element">
            <div class="qf-skeleton__tabs">
                ${'<div class="am-skeleton am-skeleton--line"></div>'.repeat(4)}
            </div>
            <div class="qf-skeleton">
                ${row.repeat(rowCount)}
            </div>
        </div>`;
}

function appendNewItems(response, currentTab) {
    let newItems = [];
    let currentTabData = [];
    
    switch(currentTab) {
        case 'all':
            newItems = response.data.all;
            currentTabData = searchResult.data.all;
            break;
        case 'orders':
            newItems = response.data.orders;
            currentTabData = searchResult.data.orders;
            break;
        case 'contacts':
            newItems = response.data.contacts;
            currentTabData = searchResult.data.contacts;
            break;
        case 'companies':
            newItems = response.data.combined_companies;
            currentTabData = searchResult.data.combined_companies;
            break;
        default:
            newItems = [];
            currentTabData = [];
    }

    const searchQuery = document.getElementById('search_query').value;
    const $searchList = document.querySelector('#search_ul_element');

    if ($searchList && newItems?.length) {
        // Remove existing sentinel
        document.querySelector('#scroll-sentinel')?.remove();
        
        // Append new items
        newItems.forEach((singleData, index) => {
            const regex = new RegExp(escapeRegExp(searchQuery), 'gi');
            const highlightedName = (singleData.name || '').replace(regex, '<span class="highlight-search">$&</span>');
            let extra_text = '';

            if(currentTab === 'all' || currentTab === 'companies')
                extra_text = `<div class="am-search-view__supporting">${singleData.extra_text}</div>`;
            else if(currentTab === 'orders')
                extra_text = `<div class="am-search-view__supporting">${singleData.status}</div>`;
            else if(currentTab === 'contacts')
                extra_text = `<div class="am-search-view__supporting">${singleData.company_name}</div>`;

            const li = document.createElement('li');
            li.id = `id_${singleData.id}`;
            li.setAttribute('rel', singleData.extra_text);
            const baseIndex = (currentTabData?.length || 0) - (newItems?.length || 0);
            li.setAttribute('data-index', baseIndex + index + 1);
            li.className = 'am-search-view__result';
            li.onclick = function() { onClickResult(this); };

            li.innerHTML = `
                <a class="href" href="${singleData.href}">
                    <div class="am-search-view__body">
                        <div class="am-search-view__headline"> ${highlightedName} </div>
                        ${extra_text}
                    </div>
                </a>
            `;
            
            $searchList.appendChild(li);
        });

        // Add new sentinel only if there's more data for this specific tab
        if (searchResult.pagination.has_more && currentTabData.length < searchResult.counts[getCountKey(currentTab)]) {
            $searchList.appendChild(createSentinel());
            // Reinitialize infinite scroll for new sentinel
            initInfiniteScroll();
        }
    }
}

function initInfiniteScroll() {
    // Reset scroll position
    const $searchListContainer = document.querySelector('#search-list');
    if ($searchListContainer) {
        $searchListContainer.scrollTop = 0;
    }

    const options = {
        root: document.querySelector('#search-list'),
        rootMargin: '100px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isLoading && searchResult.pagination.has_more) {
                searchResult.pagination.current_page++;
                const query = document.getElementById('search_query').value;
                if (query.length >= 2) {
                    performSearch(query);
                }
            }
        });
    }, options);

    // Observe all sentinel elements
    const searchList = document.querySelector('#search-list');
    if (searchList) {
        const sentinels = searchList.querySelectorAll('#scroll-sentinel');
        sentinels.forEach(sentinel => {
            observer.observe(sentinel);
        });
    }
}

function initializeIntersectionObserver() {
    const options = {
        root: document.querySelector('#search-list'),
        rootMargin: '100px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isLoading && searchResult.pagination.has_more) {
                currentPage++;
                fetchResults(document.getElementById('search_query').value, currentPage);
            }
        });
    }, options);

    // Observe the sentinel element
    const sentinel = document.createElement('div');
    sentinel.id = 'scroll-sentinel';
    sentinel.style.height = '1px';
    
    // Add sentinel to the search list
    const searchList = document.querySelector('#search-list');
    if (searchList) {
        searchList.appendChild(sentinel);
        observer.observe(sentinel);
    }
}

function dataUpdated(selectedTab = '') {
    const formattedSelectedTab = selectedTab || currentlySelectedTab;
    toggleCrossIcon();
    singleItemClicked(formattedSelectedTab);
}

function clearResults() {
    const wasLoading = isLoading;
    abortPendingSearch();
    if (wasLoading) handle_loader(true); // stop the spinner the aborted search started
    searchResult = {
        data: { all: [], orders: [], combined_companies: [], contacts: [] },
        counts: { all: 0, orders: 0, combined_companies: 0, contacts: 0 },
        pagination: { current_page: 1, total_pages: 0, has_more: false },
        search_term: ''
    };
    dataUpdated();
}

function singleItemClicked(currentElement = 'all') {
    // console.log('Tab clicked:', currentElement); // Debug log
    
    // Reset scroll position first
    const $searchListContainer = document.querySelector('#search-list');
    if ($searchListContainer) {
        $searchListContainer.scrollTop = 0;
    }
    
    currentlySelectedTab = currentElement;
    // console.log('Current tab set to:', currentlySelectedTab); // Debug log
    
    // Perform a new search with the current query for the new tab
    const currentQuery = document.getElementById('search_query').value;
    // console.log('Current query:', currentQuery); // Debug log
    
    if (currentQuery && currentQuery.length >= 2) {
        searchResult.pagination.current_page = 1; // Reset pagination
        performSearch(currentQuery);
    } else {
        updateSearchList(currentElement);
    }
    
    updateSingleItemBorder();
}

function updateSearchList(currentTab) {
    // Get the parent container
    const $searchListContainer = document.querySelector('#search-list');
    if (!$searchListContainer) return;

    // Reset scroll position first
    $searchListContainer.scrollTop = 0;

    let currentTabData;
    switch(currentTab) {
        case 'all':
            currentTabData = searchResult.data.all;
            break;
        case 'orders':
            currentTabData = searchResult.data.orders;
            break;
        case 'contacts':
            currentTabData = searchResult.data.contacts;
            break;
        case 'companies':
            currentTabData = searchResult.data.combined_companies;
            break;
        default:
            currentTabData = [];
    }

    const searchQuery = document.getElementById('search_query').value;
    
    // Create the complete structure including header
    let fullHtml = `
        <div class='search-element'>
            <div class='header-element'>
                <div class='d-flex justify-content-center gap-2 header-row w-100 px-3'>
                    <div id="all-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('all')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab all-tab">All</span>
                            <span class="d-none d-sm-block badge all-badge text-bg-primary-blue">${searchResult.counts.all}</span>
                        </div>
                        <div class="w-100 border-element all"> </div>
                    </div>
                    <div id="orders-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('orders')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab orders-tab">Orders</span>
                            <span class="d-none d-sm-block badge orders-badge text-bg-gray-13">${searchResult.counts.orders}</span>
                        </div>
                        <div class="w-100 border-element orders"> </div>
                    </div>
                    <div id="contacts-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('contacts')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab contacts-tab">Contacts</span>
                            <span class="d-none d-sm-block badge contacts-badge text-bg-gray-13">${searchResult.counts.contacts}</span>
                        </div>
                        <div class="w-100 border-element contacts"> </div>
                    </div>
                    <div id="companies-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('companies')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab companies-tab">Companies</span>
                            <span class="d-none d-sm-block badge companies-badge text-bg-gray-13">${searchResult.counts.combined_companies}</span>
                        </div>
                        <div class="w-100 border-element companies"> </div>
                    </div>
                </div>
            </div>
            <div>`;

    // Add the search results content
    if (currentTabData.length === 0 || am.$('#search_query').val() == '') {
        fullHtml += `
            <div class="no-result d-flex justify-content-center align-items-center">
                <div class="no-result--text">
                    ${get_language_translation('LANG_TEXT_NO_RESULTS_FOUND')}
                </div>
            </div>`;
            
            searchResult = {
                data: { all: [], orders: [], combined_companies: [], contacts: [] },
                counts: { all: 0, orders: 0, combined_companies: 0, contacts: 0 },
                pagination: { current_page: 1, total_pages: 0, has_more: false },
                search_term: ''
            };
    } else {
        fullHtml += `<ul id="search_ul_element">
            ${currentTabData.map((singleData, index) => {
                const regex = new RegExp(escapeRegExp(searchQuery), 'gi');
                const highlightedName = (singleData.name || '').replace(regex, '<span class="highlight-search">$&</span>');
                let extra_text = '';

                if(currentTab === 'all' || currentTab === 'companies')
                    extra_text = `<div class="am-search-view__supporting">${singleData.extra_text}</div>`;
                else if(currentTab === 'orders')
                    extra_text = `<div class="am-search-view__supporting">${singleData.status}</div>`;
                else if(currentTab === 'contacts')
                    extra_text = `<div class="am-search-view__supporting">${singleData.company_name}</div>`;

                return `
                    <li id="id_${singleData.id}" rel="${singleData.extra_text}" data-index="${index + 1}" class="am-search-view__result" onclick="onClickResult(this)">
                        <a class="href" href="${singleData.href}">
                            <div class="am-search-view__body">
                                <div class="am-search-view__headline"> ${highlightedName} </div>
                                ${extra_text}
                            </div>
                        </a>
                    </li>`;
            }).join('')}
        </ul>`;

        // Add sentinel if needed
        if (searchResult.pagination.has_more && currentTabData.length < searchResult.counts[getCountKey(currentTab)]) {
            fullHtml += createSentinel().outerHTML;
        }
    }

    // Close the remaining divs
    fullHtml += `
            </div>
        </div>`;

    // Update the entire content
    $searchListContainer.innerHTML = fullHtml;

    updateBadgeCounts();
    updateSingleItemBorder();
    initInfiniteScroll();
}

function dynamicHtml(currentElement = 'all', dataToBeRendered = []) {
    // Reset scroll position
    const $searchListContainer = document.querySelector('#search-list');
    if ($searchListContainer) {
        $searchListContainer.scrollTop = 0;
    }

    const searchQuery = document.getElementById('search_query').value;
    const formattedDataToBeRendered = searchQuery ? dataToBeRendered : [];

    return `
        <div class='search-element'>
            <div class='header-element'>
                <div class='d-flex justify-content-center gap-2 header-row w-100 px-3'>
                    <div id="all-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('all')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab all-tab">All</span>
                            <span class="d-none d-sm-block badge all-badge text-bg-primary-blue">${searchResult.counts.all}</span>
                        </div>
                        <div class="w-100 border-element all"> </div>
                    </div>
                    <div id="orders-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('orders')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab orders-tab">Orders</span>
                            <span class="d-none d-sm-block badge orders-badge text-bg-gray-13">${searchResult.counts.orders}</span>
                        </div>
                        <div class="w-100 border-element orders"> </div>
                    </div>
                    <div id="contacts-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('contacts')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab contacts-tab">Contacts</span>
                            <span class="d-none d-sm-block badge contacts-badge text-bg-gray-13">${searchResult.counts.contacts}</span>
                        </div>
                        <div class="w-100 border-element contacts"> </div>
                    </div>
                    <div id="companies-item" class="w-100 d-flex flex-column justify-content-center text-black single-item" onclick="singleItemClicked('companies')">
                        <div class="d-flex justify-content-center align-items-center gap-2 item-context">
                            <span class="selected-item tab tab companies-tab">Companies</span>
                            <span class="d-none d-sm-block badge companies-badge text-bg-gray-13">${searchResult.counts.combined_companies}</span>
                        </div>
                        <div class="w-100 border-element companies"> </div>
                    </div>
                </div>
            </div>
            <div id="search-list" class="search-list">
                ${formattedDataToBeRendered.length ? `
                    <ul id="search_ul_element">
                        ${formattedDataToBeRendered.map((singleData, index) => {
                            const regex = new RegExp(escapeRegExp(searchQuery), 'gi');
                            const highlightedName = (singleData.name || '').replace(regex, '<span class="highlight-search">$&</span>');
                            let extra_text = '';

                            if(currentElement === 'all' || currentElement === 'companies')
                                extra_text = `<div class="am-search-view__supporting">${singleData.extra_text}</div>`;
                            else if(currentElement === 'orders')
                                extra_text = `<div class="am-search-view__supporting">${singleData.status}</div>`;
                            else if(currentElement === 'contacts')
                                extra_text = `<div class="am-search-view__supporting">${singleData.company_name}</div>`;

                            let html = `<li id="id_${singleData.id}" rel="${singleData.extra_text}" data-index="${index + 1}" class="am-search-view__result" onclick="onClickResult(this)">
                                <a class="href" href="${singleData.href}">
                                    <div class="am-search-view__body">
                                        <div class="am-search-view__headline"> ${highlightedName} </div>
                                        ${extra_text}
                                    </div>
                                </a>
                            </li>`;

                            // Add sentinel when we're 10 items from the end
                            if (index === formattedDataToBeRendered.length - 10) {
                                html += `<div id="scroll-sentinel" class="am-text-muted" style="height: 20px; width: 100%;"></div>`;
                            }

                            return html;
                        }).join('')}
                    </ul>
                ` : `
                    <div class="no-result d-flex justify-content-center align-items-center">
                        <div class="no-result--text">
                            ${get_language_translation('LANG_TEXT_NO_RESULTS_FOUND')}
                        </div>
                    </div>
                `}
            </div>
        </div>`;
}

function handleSpinnerTransition($element, minIterations = 1) { // This tracks the iteration of spins to make sure the animation is complete before resolving the promise. Helps make it less twitchy
    return new Promise((resolve) => {
        $element.data('iterations', 0);
        
        const handleIteration = function() {
            const currentIterations = parseInt($element.data('iterations') || 0);
            $element.data('iterations', currentIterations + 1);
            
            if (currentIterations + 1 >= minIterations) {
                $element.off('animationiteration', handleIteration);
                $element.removeData('iterations');
                resolve();
            }
        };
        
        $element.on('animationiteration', handleIteration);
    });
}

function handle_loader(hide) {
    let $closeButton = am.$('#display_search_close');
    if(is_mobile_or_tablet()){
        $closeButton = am.$('.search-close > i');
    }

    if (hide) {
        // Handle spinner transition
        if ($closeButton.length > 0) {
            handleSpinnerTransition($closeButton).then(() => {
                $closeButton.removeClass('fas fa-spinner-third fa-spin').addClass('fa-sharp fa-solid fa-circle-xmark');
            });
        }
        updateBadgeCounts();
    } else {
        if (searchResult.pagination.current_page === 1) {
            // Fresh search with no panel open yet: open it immediately with content-shaped
            // skeleton rows so the results area shows its shape while the data loads.
            // When the panel is already open (retyping), the visible results stay put and
            // the close-icon spinner below is the only activity signal.
            if (!am.$('.quickfind').hasClass('results-open')) {
                updateHtml(currentlySelectedTab, buildSkeletonHtml());
            }

            // Show spinner in close button
            if ($closeButton.length > 0) {
                $closeButton.removeClass('fa-sharp fa-solid fa-circle-xmark').addClass('fas fa-spinner-third fa-spin');
                $closeButton.show();
            }
        }
    }
}

function updateHtml(currentElement = 'all', innerHtmlContent, hide = false) {
    // First try to find the existing search-list
    let $searchList = am.$('#search-list');
    
    // If it doesn't exist, try to find the quickfind results container and create the search-list
    if ($searchList.length === 0) {
        const $quickfindResults = am.$('#quickfind_results');
        if ($quickfindResults.length > 0) {
            $quickfindResults.html('<div id="search-list" class="search-list"></div>');
            $searchList = am.$('#search-list');
        } else {
            const $quickfind = am.$('.quickfind');
            if ($quickfind.length > 0) {
                $quickfind.append('<div id="quickfind_results"><div id="search-list" class="search-list"></div></div>');
                $searchList = am.$('#search-list');
            }
        }
    }
    
    if (hide) {
        if ($searchList.length > 0) {
            am.$('#quickfind_results').hide();
            $searchList.fadeOut(500);
        }
        return;
    }

    if ($searchList.length > 0) {
        // Ensure the parent container is visible
        const $quickfindResults = am.$('#quickfind_results');
        $quickfindResults.show();
        
        // Ensure the container is visible and properly styled
        $searchList.css({
            display: 'block',
            visibility: 'visible',
            opacity: 1,
            position: 'relative',
            width: '100%',
            zIndex: 1000
        }).show();
        
        // Update the content
        $searchList.html(innerHtmlContent);
        
        // Show the quickfind container if it exists
        am.$('.quickfind').addClass('results-open');
        
        // Show with animation
        $searchList.hide().fadeIn(300);
    }
}

function updateBadgeCounts() {
    // Only update the badge numbers, not the whole header
    am.$('.all-badge').html(searchResult.counts.all);
    am.$('.orders-badge').html(searchResult.counts.orders || '0');
    am.$('.contacts-badge').html(searchResult.counts.contacts || '0');
    am.$('.companies-badge').html(searchResult.counts.combined_companies || '0');
}

function updateSingleItemBorder() {
    const tabs = am.$('.single-item');
    if(tabs.length > 0) {
        tabs.each((i, el) => {
            const $this = am.$(el);
            if($this.length > 0) {
                const $context = $this.children('.item-context');
                if($context.length > 0) {
                    const $tab = $context.children('.tab');
                    if($tab.length > 0) {
                        if($tab.hasClass(currentlySelectedTab + '-tab'))
                            $tab.addClass('highlighted-tab');
                        else
                            $tab.removeClass('highlighted-tab');
                    }

                    const $badge = $context.children('.badge');
                    if($badge.length > 0) {
                        if($badge.hasClass(currentlySelectedTab + '-badge'))
                            $badge.addClass('text-bg-primary-blue').removeClass('text-bg-gray-13');
                        else
                            $badge.addClass('text-bg-gray-13').removeClass('text-bg-primary-blue');
                    }
                }

                const $tab_border = $this.children('.border-element');
                if($tab_border.length > 0) {
                    if($tab_border.hasClass(currentlySelectedTab))
                        $tab_border.addClass('single-item-border');
                    else
                        $tab_border.removeClass('single-item-border');
                }
            }
        });
    }
}

function onClickResult(li) {
    const type = li.getAttribute('rel');
    const baseUrl = document.querySelector('base').href;
    const targetId = li.id.substr(3); // id_345 -> 345
    let url = null;

    switch (type) {
        case 'Order':
            url = 'orders/quote/' + targetId + '/';
            break;
        case 'Company':
            url = 'accounts/companies/' + targetId + '/';
            break;
        case 'Company Contact':
            url = 'accounts/contacts/time_card/' + targetId + '/';
            break;
        case 'Individual':
            url = 'accounts/individual/' + targetId + '/';
            break;
        default:
            url = null;
    }

    if (null !== url) {
        window.location.href = baseUrl + url;
    }
}

function toggleCrossIcon() {
    const $searchQuery = am.$('#search_query');
    const $desktopCrossIcon = am.$('#display_search_close');
    
    if ($searchQuery.length === 0 || $desktopCrossIcon.length === 0) return;

    if (!$searchQuery.val()) {
        $desktopCrossIcon.hide();
    } else {
        $desktopCrossIcon.show();
    }
}

function clearLocalSearchRelatedData() {
    localStorage.removeItem('searchQuery');
    localStorage.removeItem('searchResults');
}

function quickfind_init() {
    const $quickfind = am.$('.quickfind');

    if (!$quickfind.length) {
        return;
    }

    const $searchBackdrop = $quickfind.find('.quickfind-results-backdrop');
    const $searchQuery = $quickfind.find('#search_query');
    const $searchResults = $quickfind.find('#quickfind_results');
    const $searchButton = $quickfind.find('.search-button');

    // Handle search button click
    $searchButton.on('click', () => {
        if ($searchResults.children().length > 0) {
            $quickfind.toggleClass('results-open');
        }
    });

    // Handle backdrop click
    $searchBackdrop.on('click', () => {
        $quickfind.removeClass('results-open');
    });

    // Restore previous search if exists
    const savedQuery = localStorage.getItem('searchQuery');
    const savedResults = localStorage.getItem('searchResults');
    
    if (savedQuery && savedResults) {
        try {
            $searchQuery.val(savedQuery);
            searchResult = JSON.parse(savedResults);
            dataUpdated();
        } catch (e) {
            console.error('Error restoring previous search:', e);
            clearLocalSearchRelatedData();
        }
    }
}

function null_badges() {
    am.$('.all-badge')?.html('0');
    am.$('.orders-badge')?.html('-');
    am.$('.contacts-badge')?.html('-');
    am.$('.companies-badge')?.html('-');
}

// Initialize the search functionality when the DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    quickfind_init();
    
    // Set up the clear search button
    const clearSearchButton = document.getElementById('display_search_close');
    if (clearSearchButton) {
        clearSearchButton.addEventListener('click', function() {
            const searchInput = document.getElementById('search_query');
            if (searchInput) {
                searchInput.value = '';
                clearLocalSearchRelatedData();
                clearResults();
                searchInput.focus();
            }
        });
    }
});
